import { render } from "./BatchesContainer.vue?vue&type=template&id=1645459a"
import script from "./BatchesContainer.vue?vue&type=script&lang=js"
export * from "./BatchesContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__